<template>
  <div id="password-reset" class="modal">
    <div class="modal-content">
      <div @click="$emit('close')" class="close">close</div>
      <h3>Reset Password</h3>
      <div v-if="!showSuccess">
        <p>Enter your email to reset your password</p>
        <form @submit.prevent>
          <input v-model.trim="email" type="email" placeholder="you@email.com" />
        </form>
        <p v-if="errorMsg !== ''" class="error">{{ errorMsg }}</p>
        <button @click="resetPassword()" class="button">Reset</button>
      </div>
      <p v-else>Success! Check your email for a reset link.</p>
    </div>
  </div>
</template>

<script>
import { auth } from '@/library/firebase'

export default {
  data() {
    return {
      email: '',
      showSuccess: false,
      errorMsg: ''
    }
  },
  methods: {
    async resetPassword() {
      this.errorMsg = ''

      try {
        await auth.sendPasswordResetEmail(this.email)
        this.showSuccess = true
      } catch (err) {
        this.errorMsg = err.message
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.modal {
  height: 100%;
  background: rgba(255, 255, 255, 0.95);
  position: fixed;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  &-content {
    background-color: white;
    padding: 5rem;
    border: solid 1px #ccc;
    position: relative;

    .close {
      position: absolute;
      right: 10px;
      top: 10px;
      font-size: 11px;
      cursor: pointer;
    }

    input {
      margin-bottom: 1rem;
      padding: .5rem;
      width: 100%;
    }
  }
}
</style>